// Delay (ms) after full page load before force-loading any .lazy-video the
// user never scrolled to. Real users still trigger the on-scroll load first;
// this only guarantees every video ends up with a src for contexts that don't
// run the scroll observer (e.g. Microsoft Clarity reconstructing the page with
// JS disabled to build heatmaps, which would otherwise capture empty videos).
const LAZY_VIDEO_FALLBACK_DELAY = 2500;

function loadLazyVideo(video) {
  if (!video.src && video.dataset.src) {
    video.src = video.dataset.src;
  }
}

// Skip the load-time fallback on metered or slow connections so we don't force
// heavy below-the-fold video downloads on the users most affected by them.
function prefersReducedData() {
  const connection = navigator.connection;
  return Boolean(connection && (connection.saveData || /2g/.test(connection.effectiveType || "")));
}

document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".lazy-video");

  if ("IntersectionObserver" in window) {
    let observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadLazyVideo(entry.target);
          obs.unobserve(entry.target);
        }
      });
    });

    videos.forEach(video => observer.observe(video));
  } else {
    // Fallback: load immediately
    videos.forEach(loadLazyVideo);
  }
});

// Fallback: once the page has fully loaded, force-load any videos still
// deferred so they fetch and paint even when never scrolled into view.
window.addEventListener("load", function () {
  if (prefersReducedData()) return;
  setTimeout(function () {
    document.querySelectorAll(".lazy-video").forEach(loadLazyVideo);
  }, LAZY_VIDEO_FALLBACK_DELAY);
});